import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { retrieveToken } from "../../../utils/storage";

export const adminAccount = createApi({
  reducerPath: "adminAccount",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    editAdminMail: builder.mutation({
      query: (mailData) => ({
        url: `/admin/account/email`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: mailData,
      }),
    }),
    editAdminPassword: builder.mutation({
      query: (passwordData) => ({
        url: `/admin/account/password`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: passwordData,
      }),
    }),
    doAutoMessage: builder.mutation({
      query: (body) => ({
        url: "admin/Account/chat-message-auto-reply",
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
    }),
  }),
});

export const { useEditAdminMailMutation, useEditAdminPasswordMutation, useDoAutoMessageMutation } =
  adminAccount;
